import { render } from "./ProductImageUpload.vue?vue&type=template&id=f058a0ca&scoped=true"
import script from "./ProductImageUpload.vue?vue&type=script&lang=js"
export * from "./ProductImageUpload.vue?vue&type=script&lang=js"

import "./ProductImageUpload.vue?vue&type=style&index=0&id=f058a0ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f058a0ca"]])

export default __exports__